import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'vc-feed-loader',
  templateUrl: './feed-loader.component.html',
  styleUrls: ['./feed-loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FeedLoaderComponent {}
